<wk-icon-mail-sprite-pds3 />
<icon-pds3 name="wk-icon-mail" />
@if (cardModalService.currentCard()?.contactInformation?.email) {
    <a class="wk-cm__header__icon-text" [href]="'mailto:' + cardModalService.currentCard()?.contactInformation?.email">
        {{ cardModalService.currentCard()?.contactInformation?.email | truncate: 20 }}
        @if (cardModalService.currentCard()?.contactInformation?.email.length > 20) {
            <tooltip-pds3
                position="bottom"
                mode="description"
                [openDelay]="600"
                [closeDelay]="50"
                targetSelector=".wk-cm__header__icon-email .wk-cm__header__icon-text"
            >
                {{ cardModalService.currentCard()?.contactInformation?.email }}
            </tooltip-pds3>
        }
    </a>
}

<tooltip-pds3 position="bottom" mode="indicator" [openDelay]="600" [closeDelay]="50" targetSelector=".wk-cm__header__icon-email icon-pds3">
    {{ "CardModal.Email" | translate }}
</tooltip-pds3>
